import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { tap } from 'rxjs/operators';

export const matchtestCompetencyTypes = {
  CompanyCulture: 'CompanyCulture',
  Personality: 'Personality ',
};

@Injectable({
  providedIn: 'root',
})
export class MatchService {
  public MinimumMatchPercentage = 30;
  public minimumMatchPercentageCompanyCandidatesOverview = 30;
  public minimumMatchPercentageCompanyMatchtest = 30;
  public minimumMatchPercentageStudentCompanies = 30;

  competencies: any[] | null = null;

  /**
   * Constructor
   *
   * @param http
   * @param api
   */
  constructor(private http: HttpClient, private api: ApiService) {}

  /**
   * Get all possible types of a competency
   */
  public getMatchtestCompetencyTypes() {
    return [
      {
        value: matchtestCompetencyTypes.CompanyCulture,
        name: 'Company culture',
      },
      {
        value: matchtestCompetencyTypes.Personality,
        name: 'Personality',
      },
    ];
  }

  /**
   * Get all matchtest competencies
   */
  public apiGetMatchtestCompetencies() {
    this.api.setEndpoint('matchcompetency');
    return this.api.GET().pipe(
      tap((next: any) => {
        if (next && next.hasOwnProperty('data')) {
          this.competencies = Object.assign([], next.data);
        }
      })
    );
  }

  /**
   * Get a single match test competency
   */
  apiGetMatchtestCompetency(id: string) {
    this.api.setEndpoint('matchcompetency/' + id);
    return this.api.GET();
  }

  /**
   * Add a single job posting
   *
   * @param profile_id
   * @param $params
   */
  apiAddMatchtestCompetency($params: any) {
    const params: any = {
      name: $params['name'],
      type: $params['type'],
      description: $params['description'],
    };

    this.api.setEndpoint('matchcompetency');
    return this.api.POST(params);
  }

  /**
   * Update a single job posting
   *
   * @param $id
   * @param $params
   */
  apiUpdateMatchtestCompetency($id: string, $params: any) {
    const params: any = {
      id: $params['id'],
      name: $params['name'],
      type: $params['type'],
      description: $params['description'],
    };

    this.api.setEndpoint('matchcompetency/' + $id);
    return this.api.PUT(params);
  }

  /**
   * Delete a single job posting
   *
   * @param profile_id
   * @param $params
   */
  apiDeleteMatchtestCompetency($id: string) {
    this.api.setEndpoint('matchcompetency/' + $id);
    return this.api.DELETE();
  }

  /**
   * Get all match test competencies
   */
  public apiGetMatchtestQuestions() {
    this.api.setEndpoint('matchquestion');
    return this.api.GET();
  }

  /**
   * Add a single job posting
   *
   * @param profile_id
   * @param $params
   */
  apiAddMatchtestQuestion($params: any) {
    const params: any = {
      competencyId: $params['competencyId'],
      question: $params['question'],
      answer1: $params['answer1'],
      answer2: $params['answer2'],
      answer3: $params['answer3'],
      answer4: $params['answer4'],
      answer5: $params['answer5'],
    };

    this.api.setEndpoint('matchquestion');
    return this.api.POST(params);
  }

  /**
   * Update a single job posting
   *
   * @param $id
   * @param $params
   */
  apiUpdateMatchtestQuestion($id: string, $params: any) {
    const params: any = {
      id: $params['id'],
      competencyId: $params['competencyId'],
      question: $params['question'],
      answer1: $params['answer1'],
      answer2: $params['answer2'],
      answer3: $params['answer3'],
      answer4: $params['answer4'],
      answer5: $params['answer5'],
    };

    this.api.setEndpoint('matchquestion/' + $id);
    return this.api.PUT(params);
  }

  /**
   * Delete a single job posting
   *
   * @param profile_id
   * @param $params
   */
  apiDeleteMatchtestQuestion($id: string) {
    this.api.setEndpoint('matchquestion/' + $id);
    return this.api.DELETE();
  }
}
